import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import { TradeStatusEnum } from "src/services/interfaces/TradeStatusEnum";
import { TradePhaseEnum } from "src/services/interfaces/trade/TradePhaseEnum";
import { DocumentCategoryEnum } from "src/components/Refatoracao/UploadDocument/DocumentCategoryEnum";
import { ChangeTradePhaseTypeEnum } from "src/components/Refatoracao/RejectApproveTrade/ChangeTradePhaseTypeEnum";
import ChangeTradePhaseButton from "src/components/Refatoracao/RejectApproveTrade/ChangeTradePhaseButton";
import RedirectButton from "src/components/Refatoracao/RedirectButton/RedirectButton";
import { UploadDocumentButton } from "src/components/Refatoracao/UploadDocument/UploadDocumentButton";
import { StorageTypeEnum } from "src/components/Refatoracao/UploadDocument/StorageTypeEnum";
import WorkflowTradeList from "src/components/Refatoracao/TradeList/WorkflowTradeList";
import { SearchFilterEnum } from 'src/components/Refatoracao/TradeList/SearchFilterEnum';
import PreFraudButton from 'src/components/common/PreFraudView/ViewPreFraudButton';

export default function TradeSpecialProjectPage(props: RouteComponentProps<any>) {
  const wfStatus = [TradeStatusEnum.Aberto, TradeStatusEnum.Pendencia];
  const wfPhases = [
    TradePhaseEnum.SpecialProjectApproved,
    TradePhaseEnum.ContractInformation,
    TradePhaseEnum.LegalCertificates,
    TradePhaseEnum.DocumentValidation,
    TradePhaseEnum.DocumentApproval,
    TradePhaseEnum.Analysis,
    TradePhaseEnum.Diligence,
    TradePhaseEnum.LawyerCompliance,
    TradePhaseEnum.SpecialSituation,
    TradePhaseEnum.PreCartorio,
    TradePhaseEnum.Cartorio,
    TradePhaseEnum.Funding,
    TradePhaseEnum.ContractSignature
  ];
  const cardTitle = "Trades de Projeto Especiais";

  return (
    <WorkflowTradeList onlySearch={true} searchFilter={SearchFilterEnum.SpecialProject} listStatus={wfStatus} listPhase={wfPhases} cardTitle={cardTitle} showArchivedTrades={false}>
      <RedirectButton icon="edit" buttonText="Editar" redirectWithTradeId={true} urlRedirect="/monitor/manual-trade/edit/" {...props} />
      <PreFraudButton
        hidenAsAChildren={(trade) => {
          return !trade.specialProject?.shouldExecuteWfFraud;
        }}
      />

      <ChangeTradePhaseButton
        hidenAsAChildren={(trade) => {
          return trade.phase !== TradePhaseEnum.SpecialProjectApproved;
        }}
        downloadAfterApprove={true}
        type={ChangeTradePhaseTypeEnum.approve}
        confirmModalDescriptionPlaceholder="Comentário adicional, Informe detalhes extras"
        confirmModalTitle="Finalizar trade e avançar para a próxima fase?"
        buttonText="Finalizar Trade"
        tooltipTitleDisabled=""
        tooltipTitle="Aprovar Trade"
        validateTradeInfos={true}
        isPhaseApprovalOverride={true}
      />

      <UploadDocumentButton
        hidenAsAChildren={(trade) => {
          return trade.phase !== String(TradePhaseEnum.SpecialProjectApproved);
        }}
        hoverText="Enviar RG/CNH do Cliente" title="Enviar RG/CNH" uploadCategory={DocumentCategoryEnum.ID_OWNER} storageType={StorageTypeEnum.S3} />
      <UploadDocumentButton
        hidenAsAChildren={(trade) => {
          return trade.phase !== String(TradePhaseEnum.SpecialProjectApproved);
        }}
        hoverText="Enviar Comprovante de Residencia"
        title="Comprovante de Residencia"
        uploadCategory={DocumentCategoryEnum.RESIDENTIAL_CERTIFICATE}
        storageType={StorageTypeEnum.S3}
      />
      <UploadDocumentButton
        hidenAsAChildren={(trade) => {
          return trade.phase !== String(TradePhaseEnum.SpecialProjectApproved);
        }}
        hoverText="Enviar Certidão de Casamento"
        title="Certidão de Casamento"
        uploadCategory={DocumentCategoryEnum.MARRIAGE_CERTIFICATE}
        storageType={StorageTypeEnum.S3}
      />
    </WorkflowTradeList>
  );
}



// WEBPACK FOOTER //
// ./src/pages/monitor/trade-special-project/TradeSpecialProject.page.tsx